import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EntityListComponent } from 'app/components/entity-list/entity-list.component';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { EmployeeService } from 'app/modules/vehicle-inventory/services/employee.service';
import { Rest } from 'app/rest/rest_client';
import { ExcelService } from 'app/services/excel-service/excel.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { LoadingService } from 'app/services/loading-service/loading.service';
import { NotificationsService } from 'app/services/notifications-service/notifications.service';
import { ConfirmationService } from 'primeng/api';
import { EmployeeFormComponent } from '../employee-form/employee-form.component';
import { UserFormComponent } from 'app/components/users/user-form/user-form.component';

@Component({
    selector: 'app-employee-list',
    templateUrl: './employee-list.component.html',
    styleUrls: ['./employee-list.component.css'],
    providers: [EmployeeService, ConfirmationService, UserTimePipe, ExcelService],
    standalone: false
})
export class EmployeeListComponent extends EntityListComponent<Rest.InvEmployee>
implements OnInit {

  @ViewChild(EmployeeFormComponent, { static: true })
  editForm: EmployeeFormComponent;

  @ViewChild(UserFormComponent, { static: true }) userForm: UserFormComponent;

  isCreateGranted: boolean;
  isUpdateGranted: boolean;
  isDisabledGranted: boolean;
  isReadGranted: boolean;
  isCreateUserGranted: boolean;

  constructor(
    private employeeService: EmployeeService,
    protected confirmationService: ConfirmationService,
    public notificationsService: NotificationsService,
    protected i18n: I18nService,
    authenticationService: AuthenticationService,
    protected loadingService: LoadingService,
    protected userTime: UserTimePipe,
    protected excelService: ExcelService,
    protected translateService: TranslateService
  ) {
    super(
      employeeService,
      confirmationService,
      notificationsService,
      i18n,
      authenticationService,
      loadingService,
      userTime,
      excelService
    );
    this.employeeService = employeeService;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.form = this.editForm;
    this.hasEntityFilters = false;

    this.setPermissions();
    this.isCreateUserGranted = this.authenticationService.user.canManageUsers;
  }

  protected beforeLoad() {
    if (this.paginationRequest.filters.hasOwnProperty("disabled")) {
      this.paginationRequest.filters["disabled"] = this.paginationRequest.filters["disabled"][0].toString() == "true" ? ["false"] : ["true"];
    }  
  }

  setPermissions() {
    const user = this.authenticationService.user;

    this.isCreateGranted = this.authenticationService.isRoleGranted('INV_EMPLOYEE_CREATE', user);
    this.isUpdateGranted = this.authenticationService.isRoleGranted('INV_EMPLOYEE_UPDATE', user);
    this.isReadGranted = this.authenticationService.isRoleGranted('INV_EMPLOYEE_READ', user);
    this.isDisabledGranted = this.authenticationService.isRoleGranted('INV_EMPLOYEE_DISABLE', user);

  }

  excelColumns = {};

    exportExcel() {
        this.setExcelColumns();
        let fileNameTitle = this.translateService.instant('tableManagement.employee.title');
        super.exportExcelWithColumns(fileNameTitle, this.excelColumns);
    }

    setExcelColumns() {
      const fullName = (entity: any) => `(${entity.code ?? ''})  ${entity.user?.surname1 ?? ''} ${entity.user?.surname2 ?? ''},  ${entity.user?.name ?? ''}`
      const birthDate = (entity: any) => entity.user?.birthDate ?? ''
      const nif = (entity: any) => entity.nif ?? ''
      const nifExpirationDate = (entity: any) => entity.nifExpirationDate ?? ''
      const nifExpeditionDate = (entity: any) => entity.nifExpeditionDate ?? ''
      const division = (entity: any) => `(${entity.subdivision?.division.code ?? ''}) ${entity.subdivision?.division?.name ?? ''}`
      const subDivision = (entity: any) => `(${entity.subdivision?.code ?? ''}) ${entity.subdivision?.name ?? ''}`
      const company = (entity: any) => `(${entity.ceco?.billingAccount?.code ?? ''}) ${entity.ceco?.billingAccount?.name ?? ''}`
      const ceco = (entity: any) => `(${entity.ceco?.code ?? ''}) ${entity.ceco?.description ?? ''}`
      const disabled = (entity: any) => entity.disabled ?? ''

      this.excelColumns = {
          [this.translateService.instant('drivers.table.name')]: { bindField: fullName },
          [this.translateService.instant('drivers.table.birthDate')]: { bindField: birthDate },
          [this.translateService.instant('drivers.table.nif')]: { bindField: nif },
          [this.translateService.instant('drivers.table.expirationDateNif')]: { bindField: nifExpirationDate },
          [this.translateService.instant('drivers.form.expeditionDateNif')]: { bindField: nifExpeditionDate },
          [this.translateService.instant('drivers.table.division')]: { bindField: division },
          [this.translateService.instant('drivers.table.subdivision')]: { bindField: subDivision },
          [this.translateService.instant('drivers.table.company')]: { bindField: company },
          [this.translateService.instant('drivers.table.ceco')]: { bindField: ceco },
          [this.translateService.instant('general.disabled')]: { bindField: disabled },
      }
  }

  openUserForm(){
    this.userForm.showForm(this.selectedEntities[0].user);
  }

}
